import React from "react";
import {
  DevicePhoneMobileIcon,
  EnvelopeIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";
import CustomInputField from "../../../customInputField";
import { formatPhoneNumber } from "../../../../utilities/utils";
import CustomNumberField from "../../../customNumberField";

const AdminContactInformation = ({ professionaInfo, handleChange }) => {
  const {
    cell_phone_number = "",
    email = "",
    office_phone_number = "",
    notification_email = "",
  } = professionaInfo || {};

  return (
    <div className="border border-solid border-[#EBEFF3] p-5 rounded-md mb-6 bg-white">
      <h5 className="text-base font-bold leading-[160%] text-customGray mb-4">
        Contact Information
      </h5>
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 relative mb-[22px] dark-field">
        <div>
          <h6 className="text-xs font-bold leading-[160%] text-[#869099] uppercase mb-2">
            Mobile phone number
          </h6>
          <CustomNumberField
            icon={DevicePhoneMobileIcon}
            placeHolder="(000) 000-0000"
            type="tel"
            value={
              (cell_phone_number && formatPhoneNumber(cell_phone_number)) ||
              cell_phone_number
            }
            name="cell_phone_number"
            onChange={handleChange}
            classes="bg-white lg:h-[60px] flex items-center max-w-[626px] mx-auto w-full border border-solid border-strokeColor rounded-[10px] h-[48px] overflow-hidden"
            inputClasses="border-r-0 lg:text-lg text-sm font-medium text-customGray placeholder:text-[#869099] pl-[10px] pr-[20px] bg-transparent"
          />
        </div>
        <div>
          <h6 className="text-xs font-bold leading-[160%] text-[#869099] uppercase mb-2">
            office phone number
          </h6>
          <CustomNumberField
            icon={PhoneIcon}
            placeHolder="(000) 000-0000"
            type="tel"
            value={
              (office_phone_number && formatPhoneNumber(office_phone_number)) ||
              office_phone_number
            }
            name="office_phone_number"
            onChange={handleChange}
            classes="bg-white lg:h-[60px] flex items-center max-w-[626px] mx-auto w-full border border-solid border-strokeColor rounded-[10px] h-[48px] overflow-hidden"
            inputClasses="border-r-0 lg:text-lg text-sm font-medium text-customGray placeholder:text-[#869099] pl-[10px] pr-[20px] bg-transparent"
          />
        </div>
        <div>
          <h6 className="text-xs font-bold leading-[160%] text-[#869099] uppercase mb-2">
            Professional Email
          </h6>
          <CustomInputField
            icon={EnvelopeIcon}
            placeHolder="example@gmail.com"
            type="email"
            value={email}
            name="email"
            onChange={handleChange}
            classes="bg-white lg:h-[60px] flex items-center max-w-[626px] mx-auto w-full border border-solid border-strokeColor rounded-[10px] h-[48px] overflow-hidden"
            inputClasses="border-r-0 lg:text-lg text-sm font-medium text-customGray placeholder:text-[#869099] pl-[10px] pr-[20px] bg-transparent"
          />
        </div>
        <div>
          <h6 className="text-xs font-bold leading-[160%] text-[#869099] uppercase mb-2">
            PERSONAL EMAIL (PRIVATE)
          </h6>
          <CustomInputField
            icon={EnvelopeIcon}
            placeHolder="example@gmail.com"
            type="email"
            name="notification_email"
            value={notification_email}
            onChange={handleChange}
            classes="bg-white lg:h-[60px] flex items-center max-w-[626px] mx-auto w-full border border-solid border-strokeColor rounded-[10px] h-[48px] overflow-hidden"
            inputClasses="border-r-0 lg:text-lg text-sm font-medium text-customGray placeholder:text-[#869099] pl-[10px] pr-[20px] bg-transparent"
          />
        </div>
      </div>
    </div>
  );
};

export default AdminContactInformation;
